import { t } from '../../i18n.es.js';
import React from 'react';
import { styled } from '@teko/ui';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Price = styled.div`
  text-align: right;
  margin-left: 0.5rem;
`;
const Text = styled.div`
  font-size: 11px;
`;
const Highlight = styled.div(({ theme }) => `
  font-size: 0.9rem;
  font-weight: 500;
  color: ${theme == null ? void 0 : theme.colors.red}
  `);
const StyledProductDiscount = styled.div`
  display: flex;
  justify-content: space-between;
`;
const ProductDiscount = (_a) => {
  var _b = _a, {
    discount,
    price
  } = _b, props = __objRest(_b, [
    "discount",
    "price"
  ]);
  return /* @__PURE__ */ React.createElement(StyledProductDiscount, __spreadValues({}, props), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Text, null, t("Gi\u1EA3m ngay")), /* @__PURE__ */ React.createElement(Highlight, null, discount)), /* @__PURE__ */ React.createElement(Price, null, /* @__PURE__ */ React.createElement(Text, null, t("Ch\u1EC9 c\xF2n"), " "), /* @__PURE__ */ React.createElement(Highlight, null, price)));
};

export { ProductDiscount };
